import { RRule } from 'rrule';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { useRuleRecurrenceForm } from '../../../../hooks/settings/use-rule-recurrence-form';
import { AvailabilityFormSection } from '../../availability-form/atoms/availability-form-section';
import { AvailabilityScheduleForm } from '../../availability-form/molecules/availability-schedule-form';
import { AvailabilityRuleFormValues, GetAvailabilityRuleFormFieldProps } from '../../availability-form/types';

export type RRuleHandler = (rRule: RRule | undefined) => void;

type RuleRecurrenceFormProps = {
  locationId: string | undefined;
  ruleRecurrenceFormProps: ReturnType<
    typeof useRuleRecurrenceForm<GetAvailabilityRuleFormFieldProps, AvailabilityRuleFormValues>
  >;
};

export const RuleRecurrenceForm = ({ locationId, ruleRecurrenceFormProps }: RuleRecurrenceFormProps) => {
  const { t } = useTranslation('schedule-settings');
  const { formValues } = ruleRecurrenceFormProps;

  return (
    <AvailabilityFormSection title={t('Schedule')}>
      <AvailabilityScheduleForm
        locationId={locationId}
        formProps={ruleRecurrenceFormProps}
        isRecurring={!!formValues.isRecurring}
        switchLabel={t('Repeat This Availability')}
        endDateLabel={<DatePickerLabel />}
      />
    </AvailabilityFormSection>
  );
};

const DatePickerLabel = () => {
  const { t } = useTranslation('schedule-settings');
  return (
    <>
      {t('End Date')}
      <em style={{ fontWeight: theme.font.weight.regular, color: theme.font.colors.subdued }}> ({t('optional')})</em>
    </>
  );
};
